<template>
  <div v-redirect-if-no-permission:PLANNING>
    <v-card color="#EDF1F3" v-if="this.plan">
      <v-layout align-center justify-start style="padding-left: 20px">
        <v-flex xs3>
          <div class="headline">{{ $t("maps.shifts.startDate", { date: this.plan.start_date }) }}</div>
          <div class="headline">{{ $t("maps.shifts.endDate", { date: this.plan.end_date }) }}</div>
          <div style="color: #8599a3">{{ $t("maps.shifts.shiftsCount", { count: this.shifts.length }) }}</div>
        </v-flex>
      </v-layout>
    </v-card>
    <v-card>
      <v-card-title>
        <v-layout>
          <v-flex xs6 style="padding: 8px">
            <!-- <choose-date
              clearable
              label="Filter by day"
              v-model="date_filter"
            ></choose-date> -->
            <v-select
              :label="$t('maps.shifts.planType')"
              :items="planTypes"
              :rules="[required]"
              v-model="plan_type"
              @change="getPlanShifts"
            />
          </v-flex>
          <!-- <v-flex xs6 style="padding: 8px">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Username"
                single-line
                hide-details
                @keyup.enter="getData"
              ></v-text-field>
            </v-flex> -->
        </v-layout>
      </v-card-title>
      <v-data-table
        :headers="localizedHeaders"
        :items="shifts"
        :pagination.sync="pagination"
        :total-items="totalItems"
        :rows-per-page-items="[5, 10, 15, 25, 100]"
        :loading="loading"
        :actions-extra-main="actionsExtraMain"
      >
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-center">
              <span>{{ props.item.id }}</span>
            </td>
            <td class="text-xs-center">
              <span>{{ props.item.day }}</span>
            </td>
            <td class="text-xs-center">
              <span>{{ props.item.from }}</span>
            </td>
            <td class="text-xs-center">
              <span>{{ props.item.to }}</span>
            </td>
            <td class="text-xs-center">
              <span>{{ props.item.current_drivers }}</span>
            </td>
            <td class="text-xs-center">
              <span>{{ props.item.expected_drivers }}</span>
            </td>
            <td class="text-xs-center" v-if="permission != 'Goverment'">
              <span v-if="props.item.expected_drivers">
                <v-icon @click="editShift(props.item)">edit</v-icon>
              </span>
            </td>
            <!-- <td class="text-xs-center">
              <span>
                <v-icon
                  @click="
                    $router.push({
                      path: `/shift_map/${props.item.booking_id}`,
                    })
                  "
                  >info</v-icon
                >
              </span>
            </td> -->
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
  
  <style>
.hbtn {
  float: right;
  z-index: 1;
  margin-top: 20px;
  margin-right: 20px;
  padding: 0px 45px;
}
</style>
  
  <script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";
import ChooseDate from "@/components/monaco/input/ChooseDate";

const required = (val) =>
  (val !== null && val !== undefined) || "this field is required";
const email = (val) =>
  (!!val && val.search(/^(\w|-|\.|_)+@(\w|-|\.|_)+\.\w+$/) !== -1) ||
  "this must be a valid email";
const past = (val) =>
  (!!val && moment(val).format("YYYY-MM-DD") < moment().format("YYYY-MM-DD")) ||
  "this must be past date";

export default {
  name: "Shifts",
  title() {
    return this.$t("maps.shifts.title");
  },
  components: { DataTable, ChooseDate },
  data() {
    return {
      permission: null,
      plan_type: "NORMAL",
      shifts: [],
      plan: null,
      loading: false,
      date_filter: null,
      totalItems: 0,
      headers: [
        { text: "maps.shifts.id", value: "id", sortable: false, align: "center" },
        //  { text: "Username", value: "id", sortable: false, align: "center" },
        {
          text: "maps.shifts.day",
          value: "day",
          sortable: false,
          align: "center",
        },
        {
          text: "maps.shifts.from",
          value: "from",
          sortable: false,
          align: "center",
        },
        {
          text: "maps.shifts.to",
          value: "to",
          sortable: false,
          align: "center",
        },
        {
          text: "maps.shifts.currentDrivers",
          value: "current_drivers",
          sortable: false,
          align: "center",
        },
        {
          text: "maps.shifts.expectedDriver",
          value: "expected_drivers",
          sortable: false,
          align: "center",
        },
      ],
      pagination: {
        sortBy: "id",
        rowsPerPage: 100,
      },
      formatters: {
        created_at(value) {
          return moment(value).format(" DD MMM YYYY");
        },
      },
    };
  },

  computed: {
    localizedHeaders() {
      return this.headers.map((header) => ({ ...header, text: this.$t(header.text) }));
    },
    planTypes() {
      return [
        { text: this.$t("maps.shifts.seasonal"), value: "SEASONAL" },
        { text: this.$t("maps.shifts.normal"), value: "NORMAL" },
      ];
    },
    actionsExtraMain() {
      return {
        prices: {
          title: "Captain Profile",
          icon: "account_circle",
          action: (item) =>
            this.$router.push({
              name: "CaptainProfile",
              params: { id: item.id },
            }),
        },
      };
    },
    titles() {
      return {
        id: "#",
        name: "Event name",
        start_date: "Start date",
        end_date: "End date",
        last_appliance_date: "Last appliance date",
        registered_drivers: "Registered drivers",
        created_at: "Creation date",
      };
    },
    actionsExtraMain() {
      return {
        info: {
          title: "Info",
          icon: "info",
          action: (item) =>
            this.$router.push({
              name: "EventDetails",
              params: { id: item.id },
            }),
        },
      };
    },
  },
  mounted() {
    this.permission = this.$store.state.user.roles[0].name;
    if(this.permission != 'Goverment'){
      this.headers.push({
          text: "common.edit",
          value: "edit",
          sortable: false,
          align: "center",
        },);
    }
    this.getPlanShifts();
  },
  methods: {
    getPlanShifts() {
      this.shifts = [];
      this.plan = null;
      this.loading = true;
      const params = new URLSearchParams();
      // params.append("page", this.pagination.page);
      // params.append("perPage", String(this.pagination.rowsPerPage));
      // params.append("sortBy", "id");
      params.append("plan_type", this.plan_type);
      // if (this.date_filter) {
      //   params.append("date", this.date_filter);
      // }
      this.axios
        .get("shifts/schedule_plan", { params })
        .then((res) => {
          this.plan = res.data.data;
          this.shifts = res.data.data.shifts;
          // console.log("data");
          // console.log(this.plan);
          this.loading = false;
        })
        .catch((err) => {
          // console.log("err");
          // console.log(err.response.data.message);
          this.loading = false;
          var message = err.response.data.message;
          window.getApp.$emit("SHOW_TOAST", message, "red");
        });
    },
    editShift(shift) {
      var shift_id = shift.id;
      this.$dialova({
        title: this.$t("maps.shifts.changeExpectedDriverTitle", { id: shift_id }),
        paragraph: this.$t("maps.shifts.changeExpectedDriverParagraph"),
        loader: true,
        input: this.$t("maps.shifts.enterNewNumber"),
        type: "number",
        inputValue: shift.expected_drivers,
      })
        .then(({ close, value }) => {
          var expected_drivers = value;
          this.axios
            .put(`shifts/${shift_id}/shift_expected_drivers`, {
              expected_drivers: expected_drivers,
            })
            .then((res) => {
              var message = res.data.message;
              window.getApp.$emit("SHOW_TOAST", message, "green");
              const index = this.shifts.findIndex((object) => {
                return object.id === shift_id;
              });
              if (index !== -1) {
                this.shifts[index].expected_drivers = expected_drivers;
              }
              close();
            })
            .catch((err) => {
              var message = err.response.data.message;
              window.getApp.$emit("SHOW_TOAST", message, "red");
              close();
            });
        })
        .finally(() => {
          close();
        });
    },
  },
  watch: {
    plan_type() {
      // console.log(this.plan_type);
      this.getPlanShifts();
    },
  },
};
</script>
  